import { render, staticRenderFns } from "./locked-coupon-tab.vue?vue&type=template&id=5d96768a&scoped=true&lang=pug&"
import script from "./locked-coupon-tab.vue?vue&type=script&lang=js&"
export * from "./locked-coupon-tab.vue?vue&type=script&lang=js&"
import style0 from "./locked-coupon-tab.vue?vue&type=style&index=0&id=5d96768a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d96768a",
  null
  
)

export default component.exports